import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          "Home": "Home",
          "Attendance": "Attendance",
          "Additional Settings":"Additional Settings",
          "Requests":"Requests",
          "Countries":"Countries",
          "Contracts":"Contracts",
          "Salaries and Contracts":"Salaries and Contracts",
          "Branches And Departments":"Branches And Departments",
          "currency":"currency",
          "Currenciens":"Currenciens",
          "Nationalites":"Nationalites",
          "Categories":"Categories",
          "Pages":"Pages",
          "Tasks":"Tasks",
          "Settings":"Settings",
          "SystemSettings":"SystemSettings",   
          "Salaries":"Salaries",
          "Events":"Events",
          "Date": "Date",
          "Check In Time": "Check In Time",
          "Check Out Time": "Check Out Time",
          "Work Hours": "Work Hours",
          "Overtime Hours": "Overtime Hours",
          "Late Time": "Late Time",
          "Early Check Out": "Early Check Out",
          "Designations":"Designations",
          "Employees":   "Employees",
          "Add Constracts":"Add Constracts",
          "pending": "Pending",
          "approved": "Approved",
          "refused": "Refused",
          "Enter Page Name":"Enter Page Name",
          "Page Name":"Page Name",
          "Currencies":"Currencies",
      
        },
      },
      ar: {
        translations: {
          "Home": " الرئيسية",
          "Pages":"الصفحات",
           "Articles":"المقالات",
           "Next":"التالي",  
           "Change Password":"تغيير كمة المرور",
           "Prev":"السابق",
           "Rules Detalis":"تفاصيل القواعد",
           "Nationalites Detalis":"تفاصيل الجنسيات",
           "Profile":"الملف الشخصي",
           "Designations Detalis":"تفاصيل التعيينات",
           "Shifts Detalis":"تفاصيل الدوام" ,
           "Departments Detalis":"تفاصيل الأقسام",
           "company rules Detalis":"تفاصيل لائحة الجزاءات",
           "Salaries and Contracts":"المرتبات و العقود",
          "Attendance": "الحضور و الانصراف",
          "Nationalites":"الجنسبات",
          "Device Detalis":"تفاصيل الجهاز",
          "Salaries Detalis":"تفاصيل المرتبات",
          "Cities Detalis":"تفاصيل المدن",
          "designation" :"التسمية",
          "Designations":"التعيينات",
          "department":"القسم",
          "Add Device":"إضافة جهاز",
          "duration":"المدة",
          "Add Department":"إضافه قسم",
          "Add Task":"اضافة مهمة",
          "Update company":"تعديل الشركة",
          "Edit Department":"تعديل قسم",
          "level":"المستوي",
          "Categories":"الفئات",
          "start_date":"تاريخ البداية",
          "Add Nationality":"إضافة جنسية",
          "Holidays":"الإجازات",
          "Add Holidays":"إضافة إجازات",
          "Branch Detalis" :"تفاصيل الفرع",
          "Tasks Detalis":"تفاصيل المهام",
          "Tasks" :"المهام",
          "Add Category":"اضافة فئه",
          "Add Article":"اضافه مقالة",
          "Add Page":"اضافه صفحة",
          "Edit Constracts":"تعديل العقود",
          "Enter Level":"ادخل المستوي",
          "Edit Company Rules":"تعديل لائحة الجزاءات",
          "categories Detalis":"تفاصيل الفئات",
          "Add Company Rules":"اضافة لائحة جزاءات",
          "Designations Information":"معلومات  التعيينات",
          "Time":"الوقت",
          "Add Designation":"اضافه تعيينات",
          "Salaries Detalis":"تفاصيل المرتبات",
          "Contract Detalis":"تفاصيل العقد",
          "duration type":"نوع المدة", 
          "Add Constracts":"اضافه عقود",
          "Employe":"الموظف",
          "Enter Amount":"ادخل الكمية",
          "Amount":"الكمية",
          "Type":"النوع",
          "Amount Type":"نوع الكمية",
          "Choose Amount Type":"اختار نوع الكمية",
          "Enter Description":"ادخل الوصف",
          "Requests Detalis":"تفاصيل الطلبات",
          "Payllors Detalis":"تفاصيل كشف المرتبات",
          "Choose Company":"اختار الشركة",
          "Choose Type" :"اختار النوع",
          "Image":"الصوره",
          "start_date":"تاريخ البداية",
          "end_date":"تاريخ الانتهاء",
          "join_date":"تاريخ الانضمام",
          "deserved_amount": "المبلغ المستحق",
          "status":"الحالة",
          "desreved amount":"القيمة المستحقة",
          "undeserved_amount":"القيمة غير المستحقة",
          "loan_amount":"مبلغ القرض",
          "Level":"المستوي",
          "discount_amount":"قيمة الخصم",
          "extra_amount":"مبلغ إضافي",
          "Admin":"المدير",
          "days":"الأيام", 
          "Saturday":"السبت",
          "Add Deductions":"اضافة خصومات",
          "PaidDate":"تاريخ الدفع",
          "Amount_Type":"نوع الكمية",
          "Sunday":"الأحد",
          "Monday":"الأثنين",
          "Tuesday":"الثلاثاء",
          "Payrolls" :"كشوف المرتبات",
          "type":"النوع",
          "amount":"الكمية",
          "amount_type":"نوع الكمية",
          "Salary":"المرتب",
          "late_time":"وقت التأخير",
          "date":"التاريخ",
          "company":"الشركة",
          "salary" :"المرتب",
          "company fields Detalis":"تفاصيل مجالات الشركة",
          "check_in_type":"نوع تسجيل الحضور",
          "Deductions":"الخصومات",
          "employe":"موظف", 
          "Mobile":"رقم الهاتف",
          "Late Check In":"الحضور متأخرا",
          "Bouns":"المكافئات",
          "Employe Name":"اسم الموظف",
          "Discount":"الخصم",
          "Amount":"الكمية",
          "Early Check Out":"انصراف مبكر",
          "Edit Employ":"تعديل موظف",
          "Devices Detalis":"تفاصيل الجهاز",
          "check_out_type": "نوع تسجيل الانصراف",
          "in_branch":"في الفرع",
          "in_time":"في الوقت المناسب",
          "paid_date":"تاريخ الدفع",
          "paid":"مدفوع",
          "Duration":"المده",
          "Sort":"الترتيب",
          "Salaries and Constractors":"المرتبات و العقود",
          "General Settings":"اعدادات عامة",
          "Currencies":"العملات",
          "Issue_date":"تاريخ اللإصدار",
          "Wednesday":"الاربعاء",
          "Branches And Departments":"الفروع و الأقسام",
          "Employees":"الموظفين",
          "Rules":"القواعد",
          "Slug":"الاسم المستعار",
          "Type":"النوع",
          "Thursday":"الخميس",
          "Add Salary":"إضافة مرتب",
          "Friday":"الجمعة",
          "Name_Ar":"الاسم باللغة العربية",
          "Name_En":"الاسم باللغة الانجليزية",
          "nation_id":"  رقم الهوية الوطنية" ,
          "role":"الدور",
          "Procedures":"الاجرائات",
          "Add Payrolls":"إضافة دفتر المرتبات",
          "Attendances Detalis":"تفاصيل الحضور و  الانصراف",
          "Salaries Detalis":"تفاصيل المرتبات",
          "Departments":"الأقسام",
          "Add Employ":"اضافة موظف",
          "Department":"القسم",
          "start time":"وقت البداية",
          "end time":"وقت الانتهاء",
          "start checkin":"وقت الحضور",
          "end checkin":"انتهاء الحضور",
          "Employes":"الموظفين",
          "start checkout":"بداية الانصراف",
          "end checkout": " انتهاء الانصراف",
          "Device":"الجهاز",
          "start break":"بداية الاستراحة",
          "end break":"انتهاء الاستراحة",
          "flexible hours":"ساعات مرنة",
          "flexible":"مرن",
          "break":"الاستراحة",
          "Companies":"الشركات",
          "day off":"يوم عطلة",
          "Currenciens":"العملات",
          "Countries":"الدول",
          "Field":"المجال",
          "Additional Settings":"اعدادت اضافية",
          "Country Detalis":"تفاصيل الدوله",
          "EmploymentTypes Detalis":"تفاصيل انواع العمالة",
          "Add country":"اضافة دولة",
          "Add city":"اضافة مدينة",
          "Add Level" :"اضافة مستوي",
          "Add shift":"اضافة نوبة عمل",
          "Add company":"اضافة شركة",
          "Cites" :"المدن",
          "Requests":"الطلبات",
          "Shifts":" الدوام",
          "Edit Employe Request":"تعديل طلبات الموظفين",
          "Edit Employment Type":"تعديل انواع العمالة",
          "Edit Salary":"تعديل المرتبات",
          "Edit Level":"تعديل المستوي",
          "Add Employment Type":"اضافة نوع عمالة",
          "Branches":"الفروع",
          "Company":"الشركة",
          "Add Branch":"إضافة فرع",
          "Empolyment Types":"أنواع العمالة",
          "Levels":"المستويات" ,
          "Levels Detalis":"تفاصيل المستويات",
          "Add Empolyment Type":"إضافه نوع عماله",
          "Work Shifts":"الدوام",
          "Comapny Fields":"مجالات الشركة",
          "Branches":"الفروع",
          "Add Request":"اضافه طلب",
          "Loan":"السلفة",
          "Comapny Rules":"لائحة الجزاءات",
          "Add Employe Request":"اضافة طلبات الموظفين",
          "website":"الموقع الالكتروني",
          "email":"البريد الالكتروني",
          "Company Detalis":"تفاصيل الشركة",
          "Phone-code":"رمز الهاتف الدولي",
          "Nationalities":"الجنسيات",
          "Add Company Field":"إضافة مجال الشركة",
          "Roles" :"الادوار",
          "Currency":"العملة",
          "Symbol":"الرمز",
          "Rate" :"المعدل",
          "Default":"افتراضي",
          "Symbol":"الرمز",
          "Request":"طلب",
          "SystemSettings":"اعدادت النظام",
          "Tasks":"المهام",
          "work_hours":"ساعات العمل-الاستراحه",
          "out_time":"توقيت الانصراف",
          "Task":"مهمة",
          "settings":"الاعدادت",
          "Expired_at":"تاريخ الانتهاء",
          "Settings":"الاعدادات",
          "Visits":"الزيارات",
          "Edit Request":"تعديل نوع الطلب",
          "Opreation":"العملية",
          "Show":"عرض",
          "Edit Branch":"تعديل الفرع",
          "Add EmployeAttachments":"اضافة ملحقات الموظفين",
          "Salaries":"  مكونات الراتب" ,
          "Edit Page":"تعديل الصفحات",
          "Edit Article":"تعديل المقاله",
          "Edit Category":"تعديل الفئة",
          "Edit Designation":"تعديل التعيينات",
          "Add Rules":"اضافه قواعد",
          "system_adminstrator":"مدير النظام",
          "branch_adminstrator":"مدير الفرع",
          "department_adminstrator":"مدير القسم",
          "adminstrator":"المدير",
          "Events":"المهام",
          "Date from":"التاريخ من",
          "Issue_Date":"تاريخ الإصدار",
          "constracts" :" العقود",
          "Edit shift":"تعديل الدوام",
          "requestsTypes":"انواع الطلبات",
          "Add Attendance" :"اضافة حضور",
          "Add Constracts" :"اضافة عقود",
          "Date To":"التاريخ إلي",
          "Quantity":"الكمية",
          "Add Bouns":" اضافة مكافئة ",
          "Time From":"الوقت من",
          "Time To":"الوقت إلي",
          "Date To ":"التاريخ إلي",
          "End Date":"تاريخ الانتهاء",
          "Log out":"تسجيل خروج",
          "Hello":"مرحبا",
          "Attendance has been recorded":"تم تسجيل الحضور",
          "branch":"الفرع",
          "Working Hours":"الدوام",
          "Contracts":"العقود",
          "Requests Types":"انواع الطلبات",
          "Employe Requests":"طلبات الموظفين",
          "No attendance registered today":"لم يتم تسجيل الحضور اليوم",
          "Name" :"الاسم",
          "Note":"ملاحظه",
          "Empolyes Requests Detalis":"تفاصيل طلبات الموظفين",
          "Employes Detalis":"تفاصيل الموظفين",
          "DateTo":"التاريخ إلي",
          "Country":"الدولة",
          "Date": "التاريخ",
          "Check In Time": "وقت الحضور",
          "Check Out Time": "وقت الانصراف",
          "Work Hours": "ساعات العمل",
          "Overtime Hours": "الساعات الاضافيه",
          "Late Time": "وقت التأخير",
          "Early Check Out": "وقت الانصراف المبكر",
          "profile page":"صفحة البروفايل",
          "Request Type":"نوع الطلب",
          "Request Status":"حاله الطلب",
          "Request Date":"تاريخ الطلب",
          "Reason":"السبب",
          "Show Request":"مشاهده الطلب",
          "Login":"تسجيل الدخول",
          "Enter your email & password to login":" ادخل الايميل و الباسورد لتسجيل الدخول ",
          "Sign":"تسجيل",
          "Email Address":"الايميل",
          "Password":"الباسورد",
          "RememberPassword":"تذكر الباسورد",
          "Task Title":"عنوان المهمة",
          "Employee":"الموظف",
          "Description":"الوصف",
          "Branch":"الفرع", 
          "Status":"الحالة",
          "Branch Name":"اسم الفرع",
          "January":"يناير",
          "February":"فبراير",
          "March":"مارس",
          "April":"ابريل",
          "May":"مايو",
          "Category":"الفئة",
          "Active":"نشط",
          "InActive":"غير نشط",
          "Actions":"العمليات",
          "Pages Detalis":"تفاصيل الصفحات",
          "Page Name":"اسم الصفحة",
          "application":"ابلكيشن",
          "not application":"ليس ابلكيشن",
          "Enter Page Name":"ادخل اسم الصفحة",
          "There are no salaries for this employee currently":"لاتوجد مرتبات لهذا الموظف حاليا",
          "calculate":"حساب",
          "Refues Reason":"سبب الرفض",
          "Map":"الخريطة",
          "pending": "في الانتظار",
          "approved": "تم الموافقة",
          "refused": "تم الرفض",
          "Checkin":" الحضور",
          "Checkout":"الانصراف",
          "Absent":"الغياب",
          "Early Checkout":"الانصراف مبكرا"




        },
      },
     
    },
    supportedLngs:["ar","en"],
    fallbackLng: "en",
    debug: false,
 
    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",
    lng:localStorage.getItem("i18nextLng") || "ar",
    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
